// extracted by mini-css-extract-plugin
export var divider = "_44-0";
export var dividerText = "_44-1";